import { defineStore } from "pinia";
import { ref } from "vue";
import { useBase } from "@/utils/stores/base";

export const useRentalListingAgreementReportStore = (ownerResourceId) => {
  const path = `rental-listing-agreements/${ownerResourceId}/reports/rental-listing-agreements`;
  const storeName = "rentalListingAgreementReport" + ownerResourceId;
  return defineStore(storeName, () => {
    const all = ref([]);
    const { baseFetchAll, watchRemoteResourceChange } = useBase();

    const fetchAll = async (errorCallback) => {
      all.value = await baseFetchAll(path, errorCallback);
    };

    const watchResourceChanges = async (callback) => {
      await watchRemoteResourceChange(storeName, callback);
    };

    return {
      all,
      fetchAll,
      watchResourceChanges
    };
  })();
};
